import React, { FC, useMemo, useState } from "react";
import { Dropdown, Modal } from "react-bootstrap";
import ProjectStartForm from "../Builder/Components/sidebar/ProjectStartForm";
import {
  SolutionClientType,
  SolutionType,
  useGetImportedSolutionInfoByUuidQuery,
} from "../store/slices/settingsSlice";

interface SolutionTestModalProps {
  solution: SolutionType;
  clientSolution: SolutionClientType;
}

const SolutionTestModal: FC<SolutionTestModalProps> = ({
  solution,
  clientSolution,
}) => {
  const [selectedComponentUuid, setSelectedComponentUuid] = useState("");
  const {
    data: importedSolution = {},
    isLoading,
    refetch: refetchImportedSolution,
  } = useGetImportedSolutionInfoByUuidQuery(
    { uuid: clientSolution.Uuid },
    { skip: !clientSolution.WasDeployed }
  );
  const components = useMemo(
    () =>
      (importedSolution.LatestSource?.Solution?.Components || solution.Components || [])
        .map((component: any) => ({
          component,
          projectId: importedSolution.DeployedComponents?.find(
            (deployedComponent: any) =>
              deployedComponent.ItemUuid === component.ItemUuid
          )?.ProjectID,
        }))
        .filter(({ component, projectId }: any) =>
          component.Type === "project" && Boolean(projectId)
        ),
    [importedSolution, solution.Components]
  );
  const selectedComponent = components.find(
    ({ component }: any) => component.ComponentUuid === selectedComponentUuid
  );

  return (
    <>
      <Dropdown
        onClick={(event) => event.stopPropagation()}
        onToggle={(isOpen) => {
          if (isOpen) refetchImportedSolution();
        }}
        onSelect={(componentUuid) => setSelectedComponentUuid(componentUuid || "")}
      >
        <Dropdown.Toggle variant="outline-primary" size="sm" disabled={isLoading}>
          Test
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {components.length === 0 && (
            <Dropdown.Item disabled>
              {isLoading ? "Loading components..." : "No testable components"}
            </Dropdown.Item>
          )}
          {components.map(({ component }: any) => (
            <Dropdown.Item
              key={component.ComponentUuid}
              eventKey={component.ComponentUuid}
            >
              {component.Item?.Label || component.Label || component.Role}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>

      <div onClick={(event) => event.stopPropagation()}>
        <Modal
          show={Boolean(selectedComponent)}
          onHide={() => setSelectedComponentUuid("")}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Test {selectedComponent?.component.Item?.Label || selectedComponent?.component.Role}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedComponent && (
              <ProjectStartForm
                projectID={selectedComponent.projectId}
                showHiddenVariables
                initialFormData={
                  importedSolution.SolutionClientSettings?.VariableDefaults?.[
                    selectedComponent.component.ComponentUuid
                  ]
                }
              />
            )}
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};

export default SolutionTestModal;
